import { render } from "./ViewScopeModal.vue?vue&type=template&id=dea3201c&scoped=true"
import script from "./ViewScopeModal.vue?vue&type=script&lang=js"
export * from "./ViewScopeModal.vue?vue&type=script&lang=js"

import "./ViewScopeModal.vue?vue&type=style&index=0&id=dea3201c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea3201c"]])

export default __exports__